<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">전자 계약</span>
            <span class="txt">
                발송한 계약서 내역을 확인하고, 자주 쓰는 템플릿(서식)을 등록하거나 수정할 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <span v-for="(item, index) in submenus" :key="index">
                    <router-link
                        v-show="item.valid"
                        :class="{ on: $route.name == item.name || item.name == 'SettingElectronicTemplateManage' }"
                        :to="{ ...item, params: { centerId } }"
                    >
                        {{ item.label }}
                    </router-link>
                </span>
            </div>
            <div class="table-top-container" style="margin-top: 30px">
                <div class="left-box">
                    <p class="table-top-title"><strong>템플릿 등록</strong></p>
                </div>
                <div class="right-box">
                    <a v-show="templateId > 0" class="com-btn" style="margin-right: 10px" @click="onHistory()">
                        히스토리
                    </a>
                    <a class='com-btn white' @click='$router.back()' style='color: black !important;'>목록보기</a>
                </div>
            </div>

            <div style="display: flex">
                <div style="flex: 5">
                    <div style="display: flex; align-items: center">
                        <span class='tit' style='margin-right: 30px;'>구분 <span class='imp'>*</span></span>
                        <select-form
                            style="margin-right: 10px"
                            :select-data="['직원', '회원', '기타']"
                            :select-value="['P', 'M', 'E']"
                            :selected-value="contractMemberType"
                            @update:set="(val) => setContractMemberType(val)"
                        ></select-form>
                        <input v-model='title' placeholder='템플릿 이름을 입력해 주세요.' type='text' style='flex: 1; display: none' />
                    </div>
                    <div class="contract-edge" style="margin-top: 30px">
                        <select-form
                            class="contract-send-percent"
                            style="display: flex; margin-left: auto"
                            :select-data="['25%', '50%', '70%', '100%', '120%', '150%']"
                            :select-value="[25, 50, 70, 100, 120, 150]"
                            :selected-value="contractZoom"
                            @update:set="(val) => (contractZoom = val)"
                        ></select-form>
                        <div class="contract-content">
                            <input
                                v-model="contractTitle"
                                class="contract-title-input"
                                style="margin-bottom: 20px"
                                placeholder="계약서명을 입력해 주세요."
                                :style="`font-size: ${(16 * contractZoom) / 100}px`"
                            />
                            <div class="contract-info-title" :style="`font-size: ${(16 * contractZoom) / 100}px`">
                                수신인 정보
                            </div>
                            <div class="contract-info-sub-title" :style="`font-size: ${(14 * contractZoom) / 100}px`">
                                이름
                            </div>
                            <div class="contract-info-sub-title" :style="`font-size: ${(14 * contractZoom) / 100}px`">
                                연락처
                            </div>
                            <div class="contract-info-title" :style="`font-size: ${(16 * contractZoom) / 100}px`">
                                계약 정보
                            </div>
                            <drop class="drop" @drop="handleDrop">
                                <div class="contract-info-title" :style="`font-size: ${(16 * contractZoom) / 100}px`">
                                    약관
                                </div>
                                <div style="padding: 10px 10px 0 10px" v-for="(item, index) in selectedItems">
                                    <div v-if="item.type == 1">
                                        <div class="contract-info-sub-title" style="display: flex">
                                            <input
                                                style="flex: 1; border: none"
                                                :style="`font-size: ${(14 * contractZoom) / 100}px`"
                                                v-model="item.title"
                                            />
                                            <img
                                                alt="Photo"
                                                src="/img/icons/ic_close.png"
                                                style="width: 24px; height: 24px; margin-left: 10px"
                                                @click="onDeleteItem(index)"
                                            />
                                        </div>
                                        <textarea
                                            class="contract-info-sub-title area"
                                            v-model="item.content"
                                            @change="onChangeItemContent()"
                                            :style="`font-size: ${(14 * contractZoom) / 100}px`"
                                        ></textarea>
                                    </div>
                                    <div v-else style="display: flex">
<!--                                        <div class='com-check' style='margin-top: 12px'>-->
<!--                                            <input-->
<!--                                                :id='`agree-check-${index}`'-->
<!--                                                name='check-c1'-->
<!--                                                type='checkbox'-->
<!--                                                disabled-->
<!--                                            />-->
<!--                                            <label :for='`agree-check-${index}`' style='cursor: default' class='agree-option'></label>-->
<!--                                        </div>-->
                                        <div style='flex: 1;'>
                                            <div class="contract-info-sub-title" style="display: flex">
                                                <input
                                                    style="flex: 1; border: none"
                                                    :style="`font-size: ${(14 * contractZoom) / 100}px`"
                                                    v-model="item.title"
                                                />
                                                <img
                                                    alt="Photo"
                                                    src="/img/icons/ic_close.png"
                                                    style="width: 24px; height: 24px; margin-left: 10px"
                                                    @click="onDeleteItem(index)"
                                                />
                                            </div>
                                            <textarea
                                                class="contract-info-sub-title area"
                                                v-model="item.content"
                                                @change="onChangeItemContent()"
                                                :style="`font-size: ${(14 * contractZoom) / 100}px`"
                                            ></textarea>
                                            <div
                                                v-for="(it, i) in item.options"
                                                style="display: flex; align-items: center; margin-top: 10px"
                                            >
                                                <div class="com-check">
                                                    <input
                                                        :id="`agree-check-${index}-${i}`"
                                                        name="check-c1"
                                                        type="checkbox"
                                                        disabled
                                                    />
                                                    <label
                                                        :for="`agree-check-${index}-${i}`"
                                                        class="agree-option"
							                                          style='cursor: default'
                                                    ><div v-show='item.requiredFlag' class='check-required'>*</div></label>
                                                </div>
                                                <input
                                                    v-model="it.title"
                                                    class="agree-option-input"
                                                    placeholder="선택 옵션을 입력하세요."
                                                    @change="onChangeItemContent()"
                                                    :style="`font-size: ${(14 * contractZoom) / 100}px`"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </drop>
                            <div style="display: flex">
                                <div
                                    class="contract-info-title"
                                    style="flex: 1"
                                    :style="`font-size: ${(16 * contractZoom) / 100}px`"
                                >
                                    {{ new Date() | dateFormatFilter2 }}
                                </div>
                                <div style="width: 300px; margin-top: 40px">
                                    <div style="display: flex; align-items: center">
                                        <div
                                            class="contract-info-person"
                                            :style="`font-size: ${(14 * contractZoom) / 100}px`"
                                        >
                                            수신인
                                        </div>
                                        <div
                                            class="contract-info-signature no-image"
                                            :style="`font-size: ${(14 * contractZoom) / 100}px`"
                                        >
                                            (서명)
                                        </div>
                                    </div>
                                    <div style="display: flex; align-items: center; margin-top: 10px">
                                        <div
                                            class="contract-info-person"
                                            :style="`font-size: ${(14 * contractZoom) / 100}px`"
                                        >
                                            발신인: {{ this.centerInfo.centerName }}
                                        </div>
                                        <div
                                            class="contract-info-signature no-image"
                                            v-show="senderSignImageRawData == ''"
                                            :style="`font-size: ${(14 * contractZoom) / 100}px`"
                                        >
                                            (서명)
                                        </div>
                                        <img
                                            class="contract-info-signature"
                                            v-show="senderSignImageRawData != ''"
                                            :src="senderSignImageRawData"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="flex: 2; padding-left: 20px">
                    <div class="contract-select-item">항목 선택</div>
                    <div class="contract-select-title" style="margin-top: 20px">약관</div>
                    <div style="display: flex; flex-wrap: wrap">
                        <div class="item-button-wrap" v-for="(item, index) in termList">
                            <div @click="onSelectTerm(index)">
                                <drag
                                    class="com-btn white"
                                    :class="`${checkItem(1, termList[index].s_id) > -1 ? 'disabled' : ''}`"
                                    :transfer-data="{ index: index, type: 1 }"
                                >
                                    {{ item.s_title }}
                                </drag>
                            </div>
                        </div>
                    </div>
                    <div class="contract-select-title" style="margin-top: 30px">동의/선택</div>
                    <div style="display: flex; flex-wrap: wrap">
                        <div class="item-button-wrap" v-for="(item, index) in agreeList">
                            <div @click="onSelectAgree(index)">
                                <drag
                                    class="com-btn white"
                                    :class="`${checkItem(2, agreeList[index].s_id) > -1 ? 'disabled' : ''}`"
                                    :transfer-data="{ index: index, type: 2 }"
                                >
                                    {{ item.s_title }}
                                </drag>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-btn" style="margin-top: 20px">
                <button class="com-btn" @click="onCancel">취소</button>
                <!--                <button v-show='templateId >= 0' class='com-btn white' @click='onTempSave'>임시저장</button>-->
                <button class="com-btn blue" @click="onSave">저장</button>
            </div>
        </template>
        <div v-show="historyPop" class="layer-pop square">
            <div class="view-content small-padding" style="width: auto">
                <button class="close" @click="closeHistoryPopup">
                    <span class="blind">Popup Close</span>
                </button>
                <div class="com-scroll-y">
                    <p class="pop-tit" style="font-size: 18px; margin-bottom: 15px">템플릿 히스토리</p>
                    <table class="com-table" style="margin-bottom: 40px">
                        <colgroup>
                            <col style="width: 240px" />
                            <col style="width: 100px" />
                            <col style="width: 100px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>
                                    <button
                                        :class="sortColumn == 'h_cre_dt' ? (sortType == 'DESC' ? '' : 'degree') : ''"
                                        @click="onClickModifyDt"
                                    >
                                        수정일시
                                    </button>
                                </th>
                                <th>작성자</th>
                                <th>상태</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in templateHistoryList" :key="index">
                                <td>
                                    {{ item.h_cre_dt | timestampFilter2 }}
                                </td>
                                <td>
                                    {{ item.cs_staff_name }}
                                </td>
                                <td>
                                    {{ item.h_status | getContractHistoryStatus }}
                                </td>
                            </tr>
                            <tr v-if="templateHistoryList.length === 0">
                                <td colspan="100">등록된 내역이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { Utils } from '@/assets/js/utils';
import { convertImgToDataURLviaCanvas } from '@/assets/js/common';

export default {
    name: 'SettingElectronicTemplateDetail',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
    },
    props: [],
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    watch: {
        title(newValue) {
            this.editType = 'D';
        },
        contractMemberType(newValue) {
            this.editType = 'D';
        },
        contractTitle(newValue) {
            this.editType = 'D';
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    data() {
        return {
            centerId: 0,

            templateId: this.$route.query.templateId,

            submenus: [
                { name: 'SettingElectronicContractManage', label: '계약 관리' },
                { name: 'SettingElectronicExternalDocument', label: '외부 문서' },
                { name: 'SettingElectronicTemplateManage', label: '템플릿 관리' },
                { name: 'SettingElectronicSignature', label: '서명' },
                { name: 'SettingElectronicSetting', label: '설정' },
            ],

            isLoading: false,

            contractMemberType: 'M',
            title: '',
            contractTitle: '',

            historyPop: false,
            sortColumn: 'h_cre_dt',
            sortType: 'DESC',

            templateHistoryList: [],

            termList: [],
            agreeList: [],
            selectedItems: [],

            selectedIndex: 0,

            editType: 'I',
            contractZoom: 100,
            senderSignImageRawData: '',

            centerInfo: {},
        };
    },
    methods: {
        // 초기화
        async init() {
            this.centerId = parseInt(this.cId); // 센터id

            this.isLoading = true;

            this.setSubMenu();

            await this.onSearchTermsList();
            await this.onSearchAgreeList();

            this.getSignatureList();

            if (this.templateId > 0) {
                this.getTemplateDetail();
            }
            await this.getCenterInfo();

            this.isLoading = false;
        },

        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        setSubMenu() {
            this.submenus[0].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[1].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[2].valid = this.isAllowed('ME', 6);
            this.submenus[3].valid = this.isAllowed('ME', 6);
            this.submenus[4].valid = this.isAllowed('ME', 6);
        },

        async getSignatureList() {
            try {
                this.isLoading = true;

                const response = await api.get(
                    `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/signature`
                );
                if (response && response.data) {
                    response.data.map((item) => {
                        if (item.s_rep) {
                            this.fileGroupId = item.s_file_group_id;
                            this.senderSignImageRawData = item.f_file_url;
                            convertImgToDataURLviaCanvas(item.f_file_url, (imgRawData) => {
                                this.senderSignImageRawData = imgRawData;
                            });
                        }
                    });
                }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async getTemplateDetail() {
            try {
                const { data } = await api.get(
                    `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/${this.templateId}`
                );

                this.contractMemberType = data.contractMemberType;
                this.title = data.title;
                this.contractTitle = data.contractTitle;

                this.selectedItems = data.templateInfo;

                this.autoHeightTextArea();
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async onSearchTermsList() {
            try {
                const { data } = await api.get(
                    `/admin/api/term/${this.centerId}/${this.centerStaffId}/electronic/contract/term/use`
                );
                this.termList = data;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async onSearchAgreeList() {
            try {
                const { data } = await api.get(
                    `/admin/api/term/${this.centerId}/${this.centerStaffId}/electronic/contract/agree/use`
                );
                this.agreeList = data;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        back() {
            this.$router.back();
        },

        setContractMemberType(newValue) {
            this.contractMemberType = newValue;
        },

        onCancel() {
            this.$router.back();
        },

        onTempSave() {
            this.save(false, this.editType);
        },

        onSave() {
            this.save(true, this.editType);
        },

        async save(state, editType) {
          // if (this.title == "") {
          //     alert("템플릿 이름을 입력해 주세요."); return;
          // }
            if (this.contractTitle == '') {
                alert('계약서명을 입력해 주세요.');
                return;
            }
            if (this.selectedItems.length == 0) {
                alert('약관 및 동의/선택 항목을 선택해 주세요.');
                return;
            }

            if (this.selectedIndex == 0) {
                if (!confirm('템플릿을 등록하시겠습니까?')) {
                    return;
                }
            } else {
                if (!confirm('템플릿을 변경하시겠습니까?')) {
                    return;
                }
            }

            let info = [];
            this.selectedItems.map((item) => {
                info.push({
                    ...item,
                    title: item.title,
                    content: item.content,
                    requiredFlag: item.requiredFlag,
                    options: item.options,
                });
            });

            const { data } = await api.post(
                `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template`,
                {
                    id: this.templateId,
                    title: this.title,
                    contractMemberType: this.contractMemberType,
                    contractTitle: this.contractTitle,
                    info: info,
                    saveState: state,
                    editType: editType,
                }
            );

            if (data) {
                if (this.selectedIndex == 0) {
                    alert('템플릿이 등록되었습니다.');
                } else {
                    alert('템플릿이 수정되었습니다.');
                }

                this.$router.back();
            }
        },

        checkItem(type, id) {
            let indexOf = -1;
            this.selectedItems.map((it, i) => {
                if (it.type == type && it.itemId == id) {
                    indexOf = i;
                }
            });

            return indexOf;
        },

        onSelectTerm(index) {
            const indexOf = this.checkItem(1, this.termList[index].s_id);
            if (indexOf == -1) {
                this.selectedItems.push({
                    type: 1,
                    itemId: this.termList[index].s_id,
                    title: this.termList[index].s_title,
                    content: this.termList[index].s_content,
                    requiredFlag: false,
                    options: [],
                });

                this.editType = 'A';
            } else {
                this.selectedItems.splice(indexOf, 1);

                this.editType = 'E';
            }

            this.autoHeightTextArea();
        },

        autoHeightTextArea() {
            setTimeout(() => {
                let areas = document.querySelectorAll('textarea');
                for (var i = 0; i < areas.length; i++) {
                    areas.item(i).style.height = 'auto';
                    areas.item(i).style.height = areas.item(i).scrollHeight + 'px';
                }
            }, 10);
        },

        onSelectAgree(index) {
            const indexOf = this.checkItem(2, this.agreeList[index].s_id);
            if (indexOf == -1) {
                this.selectedItems.push({
                    type: 2,
                    itemId: this.agreeList[index].s_id,
                    title: this.agreeList[index].s_title,
                    content: this.agreeList[index].s_content,
                    requiredFlag: this.agreeList[index].s_required_flag,
                    options: this.agreeList[index].options.map((item) => {
                        return { title: item.o_title };
                    }),
                });

                this.editType = 'A';
            } else {
                this.selectedItems.splice(indexOf, 1);

                this.editType = 'E';
            }

            this.autoHeightTextArea();
        },

        async onHistory() {
            try {
                let params = {
                    sortColumn: this.sortColumn,
                    sortType: this.sortType,
                };

                const { data } = await api.get(
                    `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/history/${this.templateId}`,
                    {
                        params,
                    }
                );
                this.templateHistoryList = data;

                this.historyPop = true;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        closeHistoryPopup() {
            this.historyPop = false;
        },

        // 이용권명 컬럼 클릭시
        onClickModifyDt() {
            this.sortColumn = 'h_cre_dt';
            if (this.sortType === '' || this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }

            this.onHistory();
        },

        handleDrop(info) {
            if (info.type == 1) {
                this.onSelectTerm(info.index);
            } else {
                this.onSelectAgree(info.index);
            }
        },

        onDeleteItem(index) {
            this.editType = 'E';
            this.selectedItems.splice(index, 1);
        },

        onChangeItemContent() {
            this.editType = 'D';

            this.autoHeightTextArea();
        },
    },
};
</script>
<style lang="scss"></style>
